import { createSlice } from "@reduxjs/toolkit";

const transferHistorySlice = createSlice({
  name: "transferHistory",
  initialState: {
    logs: [],
    total: 0,
    isLoading: false,
    error: null,
  },
  reducers: {
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setLogs(state, action) {
      state.logs = action.payload.logs;
      state.total = action.payload.total;
      state.isLoading = false;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setLoading, setLogs, setError } = transferHistorySlice.actions;
export default transferHistorySlice.reducer;
